// src/hooks/useFeatures.js
// Read the shop's feature flags anywhere. Example:
//   const features = useFeatures();
//   if (features.variants) { ...show variant UI... }
import { useQuery } from '@tanstack/react-query';
import api from '../config/api';

const DEFAULTS = {
  variants: true, locations: true, tax: false, default_tax_rate: 0,
  price_levels: false, track_stock: true, credit_sales: true,
  track_serials: false, delivery: false, shifts: true, discounts: true,
  second_currency: false, // when on: take/record payments in USD or the secondary currency
  add_ons: false,         // product add-on groups (modifiers) — pop-up picker in POS
  production: false,      // production items with recipes — deducts ingredients on sale
};

export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get('/api/settings').then(r => r.data),
  });
}

export function useFeatures() {
  const { data } = useSettings();
  return { ...DEFAULTS, ...(data?.features || {}) };
}